<script>
import { Podcast, PodcastCategory } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import moment from 'moment/moment'
import { cloneDeep } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        widgets: [],
        side_infos: [],
        tags: []
      },
      categoryOptions: [],
      redirectRoute: { name: 'Podcast List' }
    }
  },
  created() {
    this.fetchCategories()
  },
  methods: {
    fetchCategories() {
      const params = { page_size: 'max' }
      PodcastCategory.fetch({}, { params }).then(res => {
        this.categoryOptions = res.data.results.map(item => {
          return { label: item.title_pl, value: item.id }
        })
      })
    },
    getSidebarFields() {
      return [
        new fields.Header({
          type: 'h4',
          text: 'Data utworzenia'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'created']
        }),
        new fields.Header({
          text: this.publicationInFutureMessage,
          type: 'p',
          condition: this.publicationInFuture
        }),
        new fields.Header({
          type: 'h4',
          text: 'Data modyfikacji'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'modified'],
          disabled: true
        })
      ]
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab(), this.getSEOTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Wprowadzenie',
            modelPath: [this, 'form', 'lead'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Prowadzący',
            modelPath: [this, 'form', 'host'],
            required: true
          }),
          new fields.Select({
            label: 'Kategoria',
            modelPath: [this, 'form', 'category'],
            options: this.categoryOptions,
            required: true
          }),
          new fields.Image({
            label: 'Zdjęcie główne',
            modelPath: [this, 'form', 'image'],
            required: true
          }),
          new fields.Image({
            label: 'Zdjęcie w liście odcinków podcastowych',
            modelPath: [this, 'form', 'listing_image']
          }),
          new fields.Input({
            label: 'Numer odcinka',
            type: 'number',
            modelPath: [this, 'form', 'episode'],
            required: true
          }),
          new fields.Input({
            label: 'Link do Youtube',
            modelPath: [this, 'form', 'youtube_url'],
            required: false
          }),
          new fields.Input({
            label: 'Link do Spotify',
            modelPath: [this, 'form', 'spotify_url'],
            required: false
          }),
          new fields.WYSIWYG({
            label: 'Transkrypcja',
            modelPath: [this, 'form', 'transcription'],
            required: false,
            multilingual: true
          }),
          new fields.Input({
            label: 'Długość odcinka',
            modelPath: [this, 'form', 'content_length_seconds'],
            required: false,
            placeholder: 'MM:SS'
          })
        ]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          })
        ]
      }
    },
    onSubmit() {
      this.loading = true
      this.errors = {}
      const id = this.lookupParams
      const payload = this.getSavePayload()
      const [minutes, seconds] = payload['content_length_seconds']
        .split(':')
        .map(Number)
      payload['content_length_seconds'] = minutes * 60 + seconds
      const service = id
        ? this.service.update(this.lookupParams, payload)
        : this.service.save(payload)
      service
        .then(response => {
          this.successRedirect = true
          this.successHandler(response)
        })
        .catch(this.errorHandler)
    },
    fetchData() {
      if (this.lookupParams) {
        this.loading = true
        this.service
          .get(this.lookupParams)
          .then(response => {
            this.form = response.data
            this.form['content_length_seconds'] = `${Math.floor(
              this.form['content_length_seconds'] / 60
            )}:${this.form['content_length_seconds'] % 60}`
            this.instanceFetchCallback()
            this.formCopy = cloneDeep(this.form)
          })
          .finally(() => {
            this.loading = false
          })
      }
      this.fetchDataCallback()
    }
  },
  computed: {
    service() {
      return Podcast
    },
    publicationInFutureMessage() {
      if (!this.publicationInFuture) {
        return ''
      }
      const givenDate = moment(this.form.created)
      return `Podcast będzie dostępny dla użytkowników
           ${givenDate.format('DD/MM/YYYY')}
           o godzinie. ${givenDate.format('HH:mm')}`
    },
    publicationInFuture() {
      if (!this.form.created) {
        return false
      }
      return moment().isBefore(this.form.created)
    }
  }
}
</script>
